export const MODAL_MODIFIERS = ['wide'];
